import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

const AppSumoLogo = ({
  className,
  size,
  width = 80,
  height = 13,
  viewBox = "0 0 80 13",
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={className}
    size={size}
    width={width}
    height={height}
    viewBox={viewBox}
    aria-label={ariaLabel}
  >
    <g clipPath="url(#clip0_6358_52)">
      <path
        d="M50.4741 7.94811C50.4741 10.171 49.5122 10.171 48.999 10.171C48.5502 10.171 47.524 10.171 47.524 7.94811V1.75122H45.0869V8.35227C45.0869 10.9119 46.6902 12.6632 48.999 12.6632C51.3079 12.6632 52.9112 10.9113 52.9112 8.35227V1.75122H50.4741V7.94811Z"
        fill="black"
      />
      <path
        d="M74.5247 1.48169C73.0791 1.48169 71.6922 2.0849 70.67 3.15862C69.6477 4.23233 69.0732 5.68863 69.0732 7.20709C69.0732 8.72558 69.6477 10.1818 70.67 11.2556C71.6922 12.3293 73.0791 12.9325 74.5247 12.9325C77.6031 12.9325 79.9762 10.4403 79.9762 7.20716C79.9769 6.4551 79.8364 5.71029 79.5626 5.01539C79.2888 4.32045 78.8871 3.68902 78.3809 3.15724C77.8747 2.62545 77.2733 2.20374 76.6117 1.91623C75.95 1.62872 75.2408 1.48106 74.5247 1.48169ZM74.5247 10.3055C73.7451 10.2963 72.9999 9.9669 72.4483 9.3878C71.897 8.80874 71.5833 8.02601 71.5746 7.20716C71.5746 6.3854 71.8854 5.59729 72.4388 5.01621C72.9919 4.43514 73.7425 4.10872 74.5247 4.10872C75.3073 4.10872 76.0575 4.43514 76.611 5.01621C77.1644 5.59729 77.4749 6.3854 77.4749 7.20716C77.476 7.61434 77.4004 8.01776 77.2526 8.39416C77.1045 8.77056 76.8873 9.11256 76.6131 9.4005C76.339 9.68841 76.0132 9.91662 75.6552 10.0719C75.2968 10.2272 74.9126 10.3067 74.5247 10.3055Z"
        fill="black"
      />
      <path
        d="M5.45144 0L0 12.5959H2.75776L3.78393 10.171H7.11902L8.14518 12.5959H10.903L5.45144 0ZM4.42535 8.01536L5.45155 5.38843L6.47797 8.01536H4.42535Z"
        fill="black"
      />
      <path
        d="M17.3157 1.81885H13.3398V12.394H15.8411V9.36287H17.1879C19.6891 9.36287 21.2284 7.88102 21.2284 5.59086C21.2284 3.23342 19.7534 1.81885 17.3157 1.81885ZM18.6626 5.65855C18.6626 6.53448 18.0854 7.07312 17.1233 7.07312H15.8411V4.17644H17.1238C18.15 4.17644 18.6631 4.7153 18.6631 5.65829L18.6626 5.65855Z"
        fill="black"
      />
      <path
        d="M27.7064 1.81885H23.7305V12.394H26.2317V9.36287H27.5786C30.0799 9.36287 31.6192 7.88102 31.6192 5.59086C31.555 3.23342 30.0798 1.81885 27.7064 1.81885ZM29.0532 5.65855C29.0532 6.53448 28.476 7.07312 27.514 7.07312H26.2317V4.17644H27.5144C28.4764 4.17644 29.0537 4.7153 29.0537 5.65829L29.0532 5.65855Z"
        fill="black"
      />
      <path
        d="M38.9939 5.18656C37.006 4.6477 36.6208 4.37832 36.6208 3.7047V3.63738C36.6208 3.03119 37.1339 2.69438 38.0319 2.69438C38.93 2.69438 39.8919 3.09851 40.9821 3.83946L41.046 3.90677L42.4572 1.75137L42.3929 1.68406C41.1706 0.668758 39.6544 0.122258 38.0958 0.134983C35.6589 0.134983 33.9914 1.68418 33.9914 3.83968V3.907C33.9914 6.46665 35.6594 7.07283 37.8395 7.67902C39.7637 8.21792 40.084 8.55495 40.084 9.09359V9.1609C40.084 9.83455 39.507 10.1712 38.545 10.1712C37.391 10.1712 36.3001 9.69966 35.2098 8.75667L35.1457 8.68935L33.5425 10.7101L33.6066 10.7774C34.9618 12.0549 36.7239 12.7519 38.545 12.7307C41.1745 12.7307 42.8421 11.2489 42.8421 8.89104C42.7139 6.66871 41.2388 5.79301 38.9939 5.18656Z"
        fill="black"
      />
      <path
        d="M61.2485 12.9998L58.2345 7.61128L57.3364 12.5957H55.1558L57.4007 1.48169L61.3767 8.48684L65.161 1.48169L67.4056 12.5957H65.0968L64.1991 7.6786L61.2485 12.9998Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_6358_52">
        <rect width="80" height="13" fill="white" />
      </clipPath>
    </defs>
  </OpticksSvgElement>
);

export default AppSumoLogo;
